<!-- 带互斥关系的多选框 -->
<template>
  <el-checkbox-group :disabled="disabled" v-model="checkV" @change="handleChange">
    <template v-for="t in options">
      <el-checkbox :key="t.label" :class="{'data_report':t.label===1}" :label="t.label" :disabled="t.disabled">{{ t.name }}</el-checkbox>
      <el-select v-if="t.reportTemp" class="rep_temp" clearable placeholder="请选择" size="mini" :disabled="t.disabled" v-model="tempType">
        <el-option v-for="p in reportTemplates" :key="p.value" :label="p.label" :value="p.value"></el-option>
      </el-select>
    </template>
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'MutexContentCheckbox',
  props: {
    value: { // 绑定值（类型定为数组，即使是单选模式）
      type: Array,
      default() { return [] }
    },
    // 数据报告模板,默认CPD
    templateType: {
      type: [Number, String],
      default: 1
    },
    options: { // 下拉项集合
      type: Array,
      default() { return [] }
    },
    propOpt: {
      type: Object,
      default() {
        return {
          label: 'label', // 用作下拉项展示内容的key
          value: 'value', // 用作下拉项指令的key
          mutex: 'mutex' // 用于指定某下拉项与其他项为互斥关系的key
        }
      }
    },
    disabled: { // 是否禁用选择器
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reportTemplates: [
        { label: 'CPD模板', value: 1 },
        { label: 'CPR模板', value: 2 }
      ]
    }
  },
  computed: {
    checkV: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    tempType: {
      get() {
        return this.templateType
      },
      set(v) {
        this.$emit('update:templateType', v)
      }
    }
  },
  methods: {
    handleChange(v) {
      this.$emit('change', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.data_report {
  margin-right: 5px;
}
.rep_temp {
  width: 90px;
  margin-right: 30px;
  ::v-deep .el-input .el-input__inner {
    padding: 0 12px;
  }
  ::v-deep .el-input .el-input__suffix .el-icon-arrow-up {
    right: 5px;
    width: 14px;
  }
}
</style>
